'use client';

import Script from 'next/script';

const API_KEY = '3307bd';

const SCRIPT_URL = 'https://r.wdfl.co/rw.js';

export const InitRewardful = () => {
  return (
    <>
      <Script src={SCRIPT_URL} strategy="lazyOnload" data-rewardful={API_KEY}></Script>
      <Script id="rewardful-queue" strategy="lazyOnload">
        {`(function(w,r){w._rwq=r;w[r]=w[r]||function(){(w[r].q=w[r].q||[]).push(arguments)}})(window,'rewardful');`}
      </Script>
    </>
  );
};
